<template>
  <nav class="nav-judging-wrapper">
    <div class="nav-judging-container">
      <div class="nav-judging-comments pt-3">
        <base-icon name="message-square" class="nav-judging-sub-heading ml-3">Comment</base-icon>

        <textarea-autosize
          placeholder="Add a comment or note..."
          ref="comment"
          v-model="comment"
          :min-height="150"
          :max-height="600"
          @blur.native="updateComment()"
          class="form-control"
          id="comment"
          required
        ></textarea-autosize>
      </div>
      <div class="nav-judging-buttons">
        <div class="pb-3 d-flex justify-content-between">
          <base-icon name="award" class="nav-judging-sub-heading ml-3">Score</base-icon>
          <span
            class="pr-5 text-white"
            v-if="score"
          >{{currentScore($route.params.ceid) > -1? currentScore($route.params.ceid) : '-'}}</span>
        </div>
        <template v-if="score.score">
          <judging-dimension
            dimension="originality"
            :score="score.score.originality"
            :judgingOpen="judgingOpen"
          />
          <judging-dimension
            dimension="resonance"
            :score="score.score.resonance"
            :judgingOpen="judgingOpen"
          />
          <judging-dimension
            dimension="technical"
            :score="score.score.technical"
            :judgingOpen="judgingOpen"
          />
          <judging-dimension
            dimension="aesthetic"
            :score="score.score.aesthetic"
            :judgingOpen="judgingOpen"
          />
        </template>
      </div>

      <div class="nav-judging-controls d-flex justify-content-between align-items-center">
        <router-link :to="{name:'judging-entries'}">
          <base-icon name="chevrons-left" stroke="rgb(220,220,220)" class="btn btn-dark px-1 m-1"/>
        </router-link>
        <div
          v-if="entries"
          class="f-flex-grow-1 align-self-center counter"
        >{{currentEntry($route.params.ceid)+1}} of {{entryCount}}</div>
        <div>
          <span @click="nextPrev(-1)">
            <base-icon
              name="chevron-left"
              stroke="rgb(220,220,220)"
              class="btn btn-dark px-1 m-1"
              v-if="currentEntry($route.params.ceid)>0"
            />
          </span>
          <span @click="nextPrev(1)">
            <base-icon
              name="chevron-right"
              stroke="rgb(220,220,220)"
              class="btn btn-dark px-1 mr-1"
              @click="nextPrev(1)"
              v-if="currentEntry($route.params.ceid) < entryCount -1"
            />
          </span>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import JudgingDimension from '@/components/judging/JudgingDimension.vue'
export default {
  components: { JudgingDimension },
  data() {
    return {
      entry: {},
      score: {}
    }
  },
  methods: {
    nextPrev(incrementDecrement) {
      let entriesArray = Object.keys(this.entries)
      let index = this.currentEntry(this.$route.params.ceid)
      index !== -1
        ? this.$router.push({
            name: 'judging-entry',
            params: { ceid: entriesArray[index + incrementDecrement] }
          })
        : this.$router.push({ name: 'judging-entries' })
      window.scrollTo(0, 0)
    },
    onBlurTextarea(value) {
      console.log(value)
    },
    updateComment() {}
  },
  computed: {
    ...mapState({
      // entrants: state => state.admin.entrands
      entries: state => state.judging.entries,
      currentJudge: state => state.currentUser,
      judgingOpen: state => state.judgingOpen
    }),
    ...mapGetters({
      entryCount: 'judging/entryCount',
      currentEntry: 'judging/currentEntry',
      currentScore: 'judging/currentScore'
    }),
    comment: {
      get() {
        let entry = this.entries[this.$route.params.ceid]
        return entry.scores[this.currentJudge].comment.text
      },
      set(value) {
        let length = value.length
        var payload = {
          doc: this.$route.params.ceid,
          comment: { text: value, length: length },
          currentJudge: this.$store.state.currentUser
        }
        // console.log(payload)
        this.$store.dispatch('judging/updateComment', payload)
      }
    },
    entryIndex: function() {
      let entriesArray = Object.keys(this.entries)
      let index = entriesArray.findIndex(
        needle => needle == this.$route.params.ceid
      )
      return index
    }
  },
  mounted() {
    let key = this.$route.params.ceid
    // console.log(this.entries[key])
    this.entry = this.entries[key]
    // console.log(this.entries[key])
    let scoreKey = this.currentJudge
    this.score = this.entry.scores[scoreKey]
  }
}
</script>

<style lang="scss">
.nav-judging-wrapper {
  position: relative;
  width: 220px;
  top: -1rem;
  .nav-judging-container {
    display: flex;
    flex-direction: column;
    height: calc(100vh);
  }
  .icon {
    stroke: rgba(255, 255, 255, 1) !important;
  }
  .nav-judging-controls {
    height: 76px;

    .counter {
      color: rgb(230, 230, 230);
      font-size: 0.8em;
      font-weight: 200;
    }
  }
  .nav-judging-sub-heading {
    color: rgba(255, 255, 255, 1);
  }
  .nav-judging-buttons {
    height: auto;
    stroke: rgba(255, 255, 255, 1);
  }
  .btn {
    /* box-shadow: 2px 0px 6px 3px rgba(0, 0, 0, 0.1) !important;*/
  }
  .nav-judging-comments {
    flex: 2;
    textarea#comment {
      background: none;
      color: rgba(255, 255, 255, 0.7);
      font-weight: 200;
      border: none;
      box-shadow: none;
      + :focus {
        box-shadow: none;
        border: none;
      }
    }
  }
}
</style>
